import { HttpContext, HttpErrorResponse } from '@angular/common/http';
import { HANDLED_FORBIDDEN } from '@olv/ui-shared/features/auth';

/**
 * The error code the Settlement API sends with this refusal: MerchantDisabledException.ErrorCode on the backend,
 * pinned there by a test. Matched instead of the message, which is for people and may be reworded.
 */
export const MERCHANT_DISABLED_ERROR_CODE = 'MerchantDisabled';

/**
 * The Settlement API's refusal to show a disabled merchant to a user without merchants/access-disabled
 * (SettlementControllerBase.ValidateMerchantAccessAsync). The user's session is fine; only this merchant is off limits.
 */
export function isMerchantDisabledError(error: unknown): error is HttpErrorResponse {
  return (
    error instanceof HttpErrorResponse &&
    error.status === 403 &&
    error.error?.errorCode === MERCHANT_DISABLED_ERROR_CODE
  );
}

/** For a request to a merchant-scoped endpoint: its disabled-merchant 403 is handled by the caller, not by a logout. */
export function merchantAccessContext(): HttpContext {
  return new HttpContext().set(HANDLED_FORBIDDEN, isMerchantDisabledError);
}
